import { forwardRef } from "react";
import { twMerge } from "tailwind-merge";

export const TableWrapper = forwardRef<
  HTMLTableElement,
  React.HTMLAttributes<HTMLTableElement>
>(({ className, ...props }, ref) => (
  <div
    className={twMerge(
      "relative w-full overflow-hidden rounded-xl bg-surface-container-high dark:bg-surface-container-high-dark",
      className,
    )}
  >
    <table ref={ref} className="w-full" {...props} />
  </div>
));
TableWrapper.displayName = "TableWrapper";
